import axiosInstance from './axiosInstance';

export const GetAllMisc = async (type) => {
  try {
    const { data } = await axiosInstance.get(`/${type}/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllCategories = async () => {
  try {
    const { data } = await axiosInstance.get(`/category/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllSalesCategories = async () => {
  try {
    const { data } = await axiosInstance.get(`/salescategory/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllUnits = async () => {
  try {
    const { data } = await axiosInstance.get(`/unit/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllTransactionTypes = async () => {
  try {
    const { data } = await axiosInstance.get(`/transactiontype/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPhysicalLocation = async () => {
  try {
    const { data } = await axiosInstance.get(`/physicallocation/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPNStatus = async () => {
  try {
    const { data } = await axiosInstance.get(`/pnstatus/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllSOStatus = async () => {
  try {
    const { data } = await axiosInstance.get(`/sostatus/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllTerms = async () => {
  try {
    const { data } = await axiosInstance.get(`/term/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllShipMethod = async () => {
  try {
    const { data } = await axiosInstance.get(`/shipMethod/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPaymentStatus = async () => {
  try {
    const { data } = await axiosInstance.get(`/paymentStatus/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPOStatus = async () => {
  try {
    const { data } = await axiosInstance.get(`/postatus/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPOAddress = async () => {
  try {
    const { data } = await axiosInstance.get(`/purchaseorder/UserAddress`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllKitStatus = async () => {
  try {
    const { data } = await axiosInstance.get(`/kitstatus/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllCompanies = async () => {
  try {
    const { data } = await axiosInstance.get(`/company/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllStations = async () => {
  try {
    const { data } = await axiosInstance.get(`/gpuwb/Teststation/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllOses = async () => {
  try {
    const { data } = await axiosInstance.get(`/gpuwb/Testos/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllApps = async () => {
  try {
    const { data } = await axiosInstance.get(`/gpuwb/Testapp/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddMisc = async (type, name) => {
  try {
    const { data } = await axiosInstance.post(`/${type}`, { name: name });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditMisc = async (type, id, name) => {
  try {
    const { data } = await axiosInstance.put(`/${type}/${id}`, { name: name });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteMisc = async (type, id) => {
  try {
    const { data } = await axiosInstance.delete(`/${type}/${id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddCompany = async (name, prefix) => {
  try {
    const { data } = await axiosInstance.post(`/company`, { name: name, prefix: prefix });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditCompany = async (id, name, prefix) => {
  try {
    const { data } = await axiosInstance.put(`/company/${id}`, { name: name, prefix: prefix });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
